import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { activeBrand } from "../shared/brand";
import { initializeTheme, ThemeProvider } from "./components/ThemeProvider";
import { CustomerAppLoader } from "./CustomerAppLoader";
import { ShellViewModeProvider } from "./components/ShellViewModeProvider";
import { schedulePlatformServiceWorkerRegistration } from "./pwa/register-service-worker";
import { OperationsApp } from "./operations/OperationsApp";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: false,
    },
  },
});

const root = document.querySelector("#root");
if (!root) throw new Error(`${activeBrand.name} root element was not found`);

initializeTheme();
const operationsHost = ["ops.das.dev", "ops-staging.das.dev"].includes(window.location.hostname);
if (!operationsHost) schedulePlatformServiceWorkerRegistration();

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <ShellViewModeProvider>
        <QueryClientProvider client={queryClient}>
          {operationsHost ? <OperationsApp /> : <CustomerAppLoader />}
        </QueryClientProvider>
      </ShellViewModeProvider>
    </ThemeProvider>
  </StrictMode>,
);
